import { Linking } from "react-native";
import { FaqLink, listItemObjectTypes } from "../../../src/components/custom-drawer/CustomDrawerTypes";
import { urls } from "../../../src/resources/strings";
import { useState } from "react";

export const useDrawerActions = ({
  navigation,
  logout,
  isConnected,
  closeRightPanel,
  moveToResetPasswordScreen,
  moveToDeleteAccountScreen,
  clearSessionAndLogout,
}: useDrawerActionTypes) => {
  const [btnDisable, setBtnDisable] = useState(false);
  const [faqActive, setFaqActive] = useState(false);

  const handleItemPress = (item: listItemObjectTypes) => {
    switch (item.id) {
      case "resetPassword":
        moveToResetPasswordScreen();
        break;

      case "deleteAccount":
        moveToDeleteAccountScreen();
        break;

      case "about":
        Linking.openURL(String(urls.aboutURL));
        break;

      case "faq":
        // Linking.openURL(String(urls.faqURL));
        setFaqActive(prev=>!prev)
        break;

      case "blog":
        Linking.openURL(String(urls.blogURL));
        break;

      case "privacy":
        Linking.openURL(String(urls.privacyURL));
        break;

      case "terms":
        Linking.openURL(String(urls.termsURL));
        break;

      case "signout":
        if (isConnected) {
          setBtnDisable(true);
          clearSessionAndLogout(navigation, logout);
        } else {
          closeRightPanel();
        }
        break;

      default:
        break;
    }
  };

  const handleFaqLinkPress = (link: FaqLink, onNavigate?: (href: string) => void) => {
    switch (link.type) {
      case "phone":
      case "email":
        Linking.openURL(link.href);
        break;
      case "navigation":
        onNavigate?.(link.href); // e.g. navigate to a tab/screen by name
        break;
    }
  };

  return { handleItemPress, btnDisable, handleFaqLinkPress, faqActive, setFaqActive };
};
